import { createReducer } from '@reduxjs/toolkit';
import { changeModalVisibility, hideAllModals } from './Modal.actions';

const initialState = {} as Record<string, boolean>;

// Docs: https://redux-toolkit.js.org/api/createReducer
// CreateReducer builder api: https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
// Immer docs: https://immerjs.github.io/immer/docs/introduction
const modalReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(hideAllModals, (state, action) => initialState)
    .addCase(
      changeModalVisibility,
      (
        state,
        { payload: { visible, modalName, shouldKeepOtherModalVisibleOnShow } },
      ) => {
        if (visible) {
          if (!shouldKeepOtherModalVisibleOnShow) {
            state = {};
          }

          state[modalName] = true;
        } else {
          delete state[modalName];
        }

        return state;
      },
    ),
);

export default modalReducer;
